var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.196 22.826c2.018-8.549-3.274-17.116-11.821-19.134-8.547-2.02-17.111 3.275-19.13 11.824C2.227 24.065 7.52 32.632 16.067 34.65c8.546 2.019 17.111-3.275 19.13-11.824z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.397 27.13h-3.263V16.507h3.263V27.13zm-1.658-12.02a1.968 1.968 0 01-1.968-1.97 1.968 1.968 0 113.936 0c-.051 1.089-.932 1.97-1.968 1.97zm13.933 12.02H24.41v-5.596c0-1.503-.57-2.383-1.813-2.383-1.294 0-2.02.88-2.02 2.383v5.595h-3.16V16.51h3.16v1.45s.933-1.762 3.212-1.762c2.227 0 3.884 1.4 3.884 4.197v6.735z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleLinkedin);
export default __webpack_public_path__ + "static/media/bubble-linkedin.7001280a.svg";
export { ForwardRef as ReactComponent };